import { createAction, props } from '@ngrx/store';

import {
  ChangeUserDetailsRequest,
  CompanyResponseModel,
  UserDetails,
  UserInstallation,
  UserV2,
} from '@vi-iot/client';

export namespace UserDetailsActions {
  export enum Type {
    // From Everest Middleware
    GET_USER_DETAILS = '[USER DETAILS] Get User Details',
    GET_USER_DETAILS_SUCCESS = '[USER DETAILS] Get User Details Success',
    GET_USER_DETAILS_ERROR = '[USER DETAILS] Get User Details Error',
    INIT_USER_DETAILS_CHANGE = '[USER DETAILS] Init User Details Change',
    CHANGE_USER_DETAILS = '[USER DETAILS] Change User Details',
    CHANGE_USER_DETAILS_SUCCESS = '[USER DETAILS] Change User Details Success',
    CHANGE_USER_DETAILS_ERROR = '[USER DETAILS] Change User Details Error',
    CLOSE_CHANGE_USER_DETAILS_MODAL = '[USER DETAILS] Close Change User Details Modal',
    RESEND_CONFIRMATION_EMAIL = '[USER DETAILS] Resend Confirmation Email',
    RESEND_CONFIRMATION_EMAIL_SUCCESS = '[USER DETAILS] Resend Confirmation Email Success',
    RESEND_CONFIRMATION_EMAIL_ERROR = '[USER DETAILS] Resend Confirmation Email Error',
    REQUEST_PASSWORD_RESET = '[USER DETAILS] Request Password Reset',
    REQUEST_PASSWORD_RESET_SUCCESS = '[USER DETAILS] Request Password Reset Success',
    REQUEST_PASSWORD_RESET_ERROR = '[USER DETAILS] Request Password Reset Error',

    // From Estrella
    READ_USER_DETAILS = '[USER DETAILS] Read User Details',
    READ_USER_DETAILS_SUCCESS = '[USER DETAILS] Read User Details Success',
    READ_USER_DETAILS_ERROR = '[USER DETAILS] Read User Details Error',
    GET_USER_INSTALLATIONS = '[USER DETAILS] Get User Installations',
    GET_USER_INSTALLATIONS_SUCCESS = '[USER DETAILS] Get User Installations Success',
    GET_USER_INSTALLATIONS_ERROR = '[USER DETAILS] Get User Installations Error',

    // Other
    GET_USER_COMPANY = '[USER DETAILS] Get User Company',
    GET_USER_COMPANY_SUCCESS = '[USER DETAILS] Get User Company Success',
    GET_USER_COMPANY_ERROR = '[USER DETAILS] Get User Company Error',
    GET_USER_ROLES = '[USER DETAILS] Get User Roles',
    GET_USER_ROLES_SUCCESS = '[USER DETAILS] Get User Roles Success',
    GET_USER_ROLES_ERROR = '[USER DETAILS] Get User Roles Error',
  }

  export const getUserDetails = createAction(
    Type.GET_USER_DETAILS,
    props<{
      userId: string;
    }>()
  );

  export const getUserDetailsSuccess = createAction(
    Type.GET_USER_DETAILS_SUCCESS,
    props<{
      userId: string;
      response: {
        userDetails: UserDetails;
      };
    }>()
  );

  export const getUserDetailsError = createAction(
    Type.GET_USER_DETAILS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const initUserDetailsChange = createAction(Type.INIT_USER_DETAILS_CHANGE);

  export const changeUserDetails = createAction(
    Type.CHANGE_USER_DETAILS,
    props<{
      body: ChangeUserDetailsRequest;
    }>()
  );

  export const changeUserDetailsSuccess = createAction(
    Type.CHANGE_USER_DETAILS_SUCCESS,
    props<{
      userId: string;
      body: ChangeUserDetailsRequest;
      response: any;
    }>()
  );

  export const changeUserDetailsError = createAction(
    Type.CHANGE_USER_DETAILS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const closeChangeUserDetailsModal = createAction(Type.CLOSE_CHANGE_USER_DETAILS_MODAL);

  export const resendConfirmationEmail = createAction(
    Type.RESEND_CONFIRMATION_EMAIL,
    props<{
      loginId: string;
    }>()
  );

  export const resendConfirmationEmailSuccess = createAction(
    Type.RESEND_CONFIRMATION_EMAIL_SUCCESS
  );

  export const resendConfirmationEmailError = createAction(
    Type.RESEND_CONFIRMATION_EMAIL_ERROR,
    props<{
      error: any;
    }>()
  );

  export const requestPasswordReset = createAction(
    Type.REQUEST_PASSWORD_RESET,
    props<{
      loginId: string;
    }>()
  );

  export const requestPasswordResetSuccess = createAction(Type.REQUEST_PASSWORD_RESET_SUCCESS);

  export const requestPasswordResetError = createAction(
    Type.REQUEST_PASSWORD_RESET_ERROR,
    props<{
      error: any;
    }>()
  );

  export const readUserDetails = createAction(
    Type.READ_USER_DETAILS,
    props<{
      userId: string;
    }>()
  );

  export const readUserDetailsSuccess = createAction(
    Type.READ_USER_DETAILS_SUCCESS,
    props<{
      user: UserV2;
    }>()
  );

  export const readUserDetailsError = createAction(
    Type.READ_USER_DETAILS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const getUserInstallations = createAction(
    Type.GET_USER_INSTALLATIONS,
    props<{
      userId: string;
      limit: number;
      cursor: string;
      userDetails: UserDetails;
    }>()
  );

  export const getUserInstallationsSuccess = createAction(
    Type.GET_USER_INSTALLATIONS_SUCCESS,
    props<{
      installations: UserInstallation[];
      cursor: string;
    }>()
  );

  export const getUserInstallationsError = createAction(
    Type.GET_USER_INSTALLATIONS_ERROR,
    props<{
      error: any;
    }>()
  );

  export const getUserCompany = createAction(
    Type.GET_USER_COMPANY,
    props<{ customerNumber: string }>()
  );

  export const getUserCompanySuccess = createAction(
    Type.GET_USER_COMPANY_SUCCESS,
    props<{ company: CompanyResponseModel }>()
  );

  export const getUserCompanyError = createAction(
    Type.GET_USER_COMPANY_ERROR,
    props<{ error: any }>()
  );
}
